import { DiamondMark } from "./DiamondMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2A2423] text-[#FDFBF7] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <DiamondMark className="w-8 h-8 text-[#D8A7A1]" />
              <span className="font-serif text-xl tracking-[0.18em] uppercase">
                The Diamond Effect <span className="italic text-[#D8A7A1]">Affairs</span>
              </span>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-[#FDFBF7]/60">
              Event styling, balloon garlands and private chef catering — Caribbean, Asian &amp; American cuisine — for
              life&apos;s most luminous moments.
            </p>
          </div>
          <div className="flex gap-20">
            <div>
              <p className="text-xs uppercase tracking-[0.22em] text-[#D8A7A1] mb-5">Explore</p>
              <div className="flex flex-col gap-3 text-sm text-[#FDFBF7]/70">
                <a href="#services" data-testid="footer-services-link" className="hover:text-[#FDFBF7] transition-colors duration-300">Services</a>
                <a href="#events" data-testid="footer-events-link" className="hover:text-[#FDFBF7] transition-colors duration-300">Events</a>
                <a href="#catering" data-testid="footer-catering-link" className="hover:text-[#FDFBF7] transition-colors duration-300">Catering</a>
                <a href="#booking" data-testid="footer-booking-link" className="hover:text-[#FDFBF7] transition-colors duration-300">Book an Affair</a>
              </div>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.22em] text-[#D8A7A1] mb-5">Contact</p>
              <div className="flex flex-col gap-3 text-sm text-[#FDFBF7]/70">
                <a href="mailto:dannae28tilbanye@gmail.com" data-testid="footer-email-link" className="hover:text-[#FDFBF7] transition-colors duration-300 break-all">
                  dannae28tilbanye@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#FDFBF7]/10 flex flex-wrap justify-between gap-4 text-xs text-[#FDFBF7]/40 tracking-[0.15em] uppercase">
          <span>© {new Date().getFullYear()} The Diamond Effect Affairs</span>
          <span>Styled to shine</span>
        </div>
      </div>
    </footer>
  );
}
